// eslint-disable-next-line import/no-cycle
import MagicLinkForm from 'profile/login/forms/MagicLinkFormNoRoutes';

const MagicLinkForms = (props) => {
  const { onLogin, redirectLink } = props;
  return (
    <div className="c7-account-login--returning-customer">
      <MagicLinkForm onLogin={onLogin} redirectLink={redirectLink} />
    </div>
  );
};

export default MagicLinkForms;
